import React from 'react';
import { CheckPicker } from 'rsuite';
import { CheckPickerProps } from 'rsuite/lib/CheckPicker';
import styles from './Select.module.scss';

type SelectProps = {
  label: string;
  placeholder?: string;
  value?: CheckPickerProps['value'];
  disabled?: CheckPickerProps['disabled'];
  data?: CheckPickerProps['data'];
  cleanable?: CheckPickerProps['cleanable'];
  searchable?: CheckPickerProps['searchable'];
  locale?: CheckPickerProps['locale'];
  filter?: CheckPickerProps['filter'];
  className?: string;
  onChange?: CheckPickerProps['onChange'];
  onSelect?: CheckPickerProps['onSelect'];
  onSearch?: CheckPickerProps['onSearch'];
  onClean?: CheckPickerProps['onClean'];
  onClose?: CheckPickerProps['onClose'];
  onOpen?: CheckPickerProps['onOpen'];
  renderExtraFooter?: CheckPickerProps['renderExtraFooter'];
  renderMenu?: CheckPickerProps['renderMenu'];
};

export const Select = ({
  label,
  placeholder,
  value,
  disabled,
  data,
  cleanable,
  searchable,
  locale,
  filter,
  className,
  onChange,
  onSelect,
  onSearch,
  onClean,
  onClose,
  onOpen,
  renderExtraFooter,
  renderMenu,
}: SelectProps) => {
  const renderPlaceholder = value => (
    <>
      <span>{value && placeholder}</span>
      <span className={styles.counter}>{value && value?.length}</span>
    </>
  );
  return (
    <div className={[styles['select-container'], className].join(' ')}>
      <span className={styles['select-label']}>{label}:</span>
      <CheckPicker
        id="check-picker-detailing"
        className={styles['select-detailing']}
        appearance="subtle"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        data={data}
        cleanable={cleanable}
        onChange={onChange}
        onSelect={onSelect}
        onSearch={onSearch}
        onClean={onClean}
        onClose={onClose}
        onOpen={onOpen}
        searchable={searchable}
        filter={filter}
        locale={locale}
        renderExtraFooter={renderExtraFooter}
        renderMenu={renderMenu}
        renderValue={renderPlaceholder}
      />
    </div>
  );
};
